// store index.js
import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex)
// 初始化时用localStorage.getItem('token'),这样子刷新页面就无需重新登录
const store = new Vuex.Store({
  state:{
    RealName: window.localStorage.getItem('RealName'),
    token: window.localStorage.getItem('token'),
    UserId: window.localStorage.getItem('UserId')
  },
  mutations:{
    //将token保存到localStorage里，token表示登陆状态
    SET_TOKEN: (state, data) => {
      state.token = data
      window.localStorage.setItem('token', data)
    },
    //获取用户名
    SET_RealName: (state, data) => {
      // 把用户名存起来
      state.RealName = data
      window.localStorage.setItem('RealName', data)
    },
    SET_UserId: (state, data) => {
      // 把用户名存起来
      state.UserId = data
      window.localStorage.setItem('UserId', data)
    },
    //登出
    LOGOUT: (state) => {
      // 登出的时候要清除token
      state.token = null
      state.RealName = null
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('RealName')
      window.localStorage.removeItem('UserId')
      router.push({
        path:'/login'
      })
    }
  }
})
export default store




// WEBPACK FOOTER //
// ./src/store/index.js